(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("candidateTagsListing", {
            controller: candidateTagsListing,
            bindings: {
                brandId: '<',
                candidateId: '<'
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/candidate-tags-listing/candidate-tags-listing.component.html'
        });

    candidateTagsListing.$inject = ['tagsDataService', 'tagsEventsDataService'];

    function candidateTagsListing(tagsDataService, tagsEventsDataService) {
        var self = this;

        var onBeforeAssignHandler = function (brandId, candidatesIds, tags) {
            var candidateTagsIds = _.pluck(self.candidateTags, "id");

            for (var i in tags) {
                candidateTagsIds.indexOf(tags[i].id) === -1 && self.candidateTags.push(tags[i]);
            }
        };

        var onBeforeUnassignHandler = function (brandId, candidatesIds, tags) {
            var tagsIds = _.pluck(tags, "id");

            self.candidateTags = _.filter(self.candidateTags, function (candidateTag) {
                return tagsIds.indexOf(candidateTag.id) === -1;
            });
        };

        var onUnassignFailedHandler = function (brandId, candidatesIds, tags, err) {
            onBeforeAssignHandler(brandId, candidatesIds, tags, err);
            HNotifications.show({
                title: this.$filter('translate')("Tags Unassign Failed"),
                icon: "fa-times",
                type: "danger",
                timeout: 3000
            });
        };

        var onAssignFailedHandler = function (brandId, candidatesIds, tags, err) {
            onBeforeUnassignHandler(brandId, candidatesIds, tags);
            HNotifications.show({
                title: this.$filter('translate')("Tags Assign Failed"),
                icon: "fa-times",
                type: "danger",
                timeout: 3000
            });
        };

        var onAfterUpdateHandler = function(brandId, tag, res){
            for (var i in self.candidateTags) {
                if (tag.id === self.candidateTags[i].id) {
                    self.candidateTags[i] = angular.extend(self.candidateTags[i], tag);
                }
            }
        };

        var onAfterDeleteHandler = function (brandId, tagId, res) {
            for (var i in self.candidateTags) {
                if (tagId === self.candidateTags[i].id) {
                    self.candidateTags.splice(i, 1);
                    break;
                }
            }
        };

        var onBeforeAssignEvent = tagsEventsDataService.onAfterAssign(onBeforeAssignHandler);
        var onBeforeUnassignEvent = tagsEventsDataService.onBeforeUnassign(onBeforeUnassignHandler);

        var onUnassignFailedEvent = tagsEventsDataService.onUnassignFailed(onUnassignFailedHandler);
        var onAssignFailedEvent = tagsEventsDataService.onAssignFailed(onAssignFailedHandler);

        var onAfterUpdateEvent = tagsEventsDataService.onAfterUpdate(onAfterUpdateHandler);
        var onAfterDeleteEvent = tagsEventsDataService.onAfterDelete(onAfterDeleteHandler);

        self.unassignTag = function (tag) {
            tagsDataService.unassignTagsFromCandidates(self.brandId, [self.candidateId], [tag]).then(function () {});
        };

        self.$onInit = function () {
            tagsDataService
                .getByCandidatesIds(self.brandId, [self.candidateId])
                .then(function (res) {
                    self.candidateTags = res?.[0]?.tags ?? [];
                }, function (err) {
                    console.error(err);
                });
        };

        self.$onDestroy = function () {
            tagsEventsDataService.off(onBeforeAssignEvent);
            tagsEventsDataService.off(onBeforeUnassignEvent);

            tagsEventsDataService.off(onAssignFailedEvent);
            tagsEventsDataService.off(onUnassignFailedEvent);

            tagsEventsDataService.off(onAfterUpdateEvent);
            tagsEventsDataService.off(onAfterDeleteEvent);
        };
    }
})();
